import { module } from 'stereomodularjs';
//import vue template compiler
import Vue from 'vue';
import { compileToFunctions } from 'vue-template-compiler';
import axios from 'axios';
//import { random } from 'gsap';


export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        //Get next tag stereo after this.el and store it
        const template = this.el.nextElementSibling;
        //console.log(template);
        this.initVUE(template);
        template.remove();
    }

    initVUE(template) {
        Vue.config.devtools = true;
        Vue.config.productionTip = false;
        //Cast template as string
        template = template.innerHTML;
        const res = compileToFunctions(template);
        const app = new Vue({
            el: this.el,
            data: {
                groups: [],
                group: null,
            },
            methods: {
                async fetchGroups() {
                    //axios GET /wp-json/cdj/v1/groups
                    return axios.get('/wp-json/cdj/v1/groups?'+Math.random().toString(36).substring(2,7))
                        .then((response) => {
                            this.groups = response.data;
                            this.group = response.data[0].term_id;
                            return response.data;
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                },
                getStatus(week){
                    const count  = week.count;
                    const max    = week.metadata.total_place;

                    if(count >= max){
                        return 'Complet';
                    } //else if 75% of max return Places limitées
                    else if(count >= (max * 0.75)){
                        return 'Places limitées';
                    } //else return Places disponibles
                    else {
                        return 'Disponibles';
                    }
                },
                weekDateFormatted(week){
                    //Exemple 1er au 5 juillet from start_date to end_date
                    let start = new Date(week.metadata.start_date+'T00:00:00');
                    let end = new Date(week.metadata.end_date+'T00:00:00');
                    let options = {month: 'long', day: 'numeric' };
                    if(start.getMonth() == end.getMonth()){
                        return start.getDate() + ' au ' + end.getDate() + ' ' + start.toLocaleDateString('fr-FR', { month: 'long' });
                    }

                    return start.toLocaleDateString('fr-FR', options) + ' au ' + end.toLocaleDateString('fr-FR', options);
                },
                getWeeks(group){
                    //Get weeks from groups array with term_id == group
                    let weeks = this.groups.filter(function (el) {
                        return el.term_id == group;
                    });
                    if(weeks.length == 0){
                        return [];
                    }
                    //Return weeks array
                    return weeks[0].weeks;
                },
            },
            ...res,
            mounted() {
                this.fetchGroups();
            }
        });
    }
}